<template>
  <base-modal :modal-id="modalId">
    <template v-slot:header>
      <h4 class="modal-title mb-0">+ {{ _T('Add Extra Instructions') }}</h4>
    </template>

    <template v-slot:modal-body>
      <div class="customized-box multi-select">
        <h6 class="title">
          {{ _T('Extra Instruction') }}
          <span class="optional">({{ _T('optional') }})</span>
        </h6>
        <textarea
          class="form-control"
          id="exampleFormControlTextarea1"
          rows="5"
          v-model="extraInstructions"
        ></textarea>
      </div>
      <div class="btns mt-4">
        <button
          type="button"
          class="btn btn-outline"
          @click="$bvModal.hide(modalId)"
        >
          {{ _T('Cancel') }}
        </button>
        <button
          type="button"
          class="btn btn-solid"
          data-dismiss="modal"
          @click="addInstructions"
        >
          {{ _T('Add') }}
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/Modals/BaseModal'
import { mapGetters } from 'vuex'
export default {
  name: 'AddAddressInstructions',
  components: {
    BaseModal,
  },
  data: () => ({
    modalId: 'add-address-instructions',
    extraInstructions: '',
  }),
  computed: {
    ...mapGetters(['_T', 'order_address_instructions']),
  },
  methods: {
    addInstructions () {
      this.$store.commit('ORDER_ADDRESS_INSTRUCTIONS', this.extraInstructions)
      this.$bvModal.hide(this.modalId)
    },
  },
  created () {
    this.extraInstructions = this.order_address_instructions || ''
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .edit-profile {
    .modal-body {
      .btns {
        text-align: left;
        .btn {
          + .btn {
            margin-right: $px8;
            margin-left: unset;
          }
        }
      }
      label {
        text-align: right;
        float: right;
      }
    }
  }
}
</style>
